import clsx from "clsx";

const Divider = ({ className }) => {
  return (
    <div className={clsx("relative", className)}>
      <div className="w-full border-t border-gray-300" />
    </div>
  );
};

export default Divider;